import './App.css';
import React from 'react';
import Header from './Header';
import SearchBar from './SearchBar';

const  App=()=> {
  return (
    <React.Fragment>
    <Header />
    <SearchBar />
    </React.Fragment>
  );
}

export default App;
